import { maskCpf, maskCnpj, maskPhoneBr } from "../../utils/masks";
import { formatBrlCurrencyForDoc } from "../../utils/brFormat";

function formatCpfPreview(value) {
  return maskCpf(value ?? "");
}

function formatCnpjPreview(value) {
  return maskCnpj(value ?? "");
}

function formatPhonePreview(value) {
  return maskPhoneBr(value ?? "");
}

function formatDateBR(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    if (!Number.isNaN(dt.getTime())) return dt.toLocaleDateString("pt-BR");
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return s;
  return parsed.toLocaleDateString("pt-BR");
}

function formatDocumentoByTipo(tipo, value) {
  return String(tipo).toLowerCase() === "cnpj"
    ? formatCnpjPreview(value)
    : formatCpfPreview(value);
}

function signatureBlockRecebedor(name, documento, tipo) {
  const doc = formatDocumentoByTipo(tipo, documento);
  return `_______________________________\n${name ?? ""}\nCPF/CNPJ: ${doc}`;
}

export function reciboSimplesResolver(formData, userConfig) {
  const safeUserConfig = userConfig || {};
  const data = { ...safeUserConfig, ...formData };

  data.ENDERECO_IMOBILIARIA =
    formData.ENDERECO_IMOBILIARIA !== undefined &&
    formData.ENDERECO_IMOBILIARIA !== null
      ? formData.ENDERECO_IMOBILIARIA
      : safeUserConfig.endereco_imobiliaria || "";
  data.CELULAR_IMOBILIARIA = formatPhonePreview(
    formData.CELULAR_IMOBILIARIA !== undefined &&
      formData.CELULAR_IMOBILIARIA !== null
      ? formData.CELULAR_IMOBILIARIA
      : safeUserConfig.celular_imobiliaria || ""
  );
  data.EMAIL_IMOBILIARIA =
    formData.EMAIL_IMOBILIARIA !== undefined &&
    formData.EMAIL_IMOBILIARIA !== null
      ? formData.EMAIL_IMOBILIARIA
      : safeUserConfig.email_imobiliaria || "";
  data.CRECI_IMOBILIARIA =
    formData.CRECI_IMOBILIARIA !== undefined &&
    formData.CRECI_IMOBILIARIA !== null
      ? formData.CRECI_IMOBILIARIA
      : safeUserConfig.creci_imobiliaria || "";
  data.SITE_IMOBILIARIA =
    formData.SITE_IMOBILIARIA !== undefined &&
    formData.SITE_IMOBILIARIA !== null
      ? formData.SITE_IMOBILIARIA
      : safeUserConfig.site_imobiliaria || "";

  if (formData.VALOR != null && formData.VALOR !== "") {
    data.VALOR = formatBrlCurrencyForDoc(formData.VALOR);
  }
  if (formData.VALOR_EXTENSO != null) {
    data.VALOR_EXTENSO = String(formData.VALOR_EXTENSO);
  }

  const tipoDocPagador = formData.TIPO_DOCUMENTO_PAGADOR || "cpf";
  if (formData.CPF_CNPJ_PAGADOR != null && formData.CPF_CNPJ_PAGADOR !== "") {
    data.CPF_CNPJ_PAGADOR = formatDocumentoByTipo(
      tipoDocPagador,
      formData.CPF_CNPJ_PAGADOR
    );
  }

  const tipoDocRecebedor = formData.TIPO_DOCUMENTO_RECEBEDOR || "cpf";
  if (formData.CPF_CNPJ_RECEBEDOR != null && formData.CPF_CNPJ_RECEBEDOR !== "") {
    data.CPF_CNPJ_RECEBEDOR = formatDocumentoByTipo(
      tipoDocRecebedor,
      formData.CPF_CNPJ_RECEBEDOR
    );
  }

  if (formData.NOME_RECEBEDOR || formData.CPF_CNPJ_RECEBEDOR) {
    data.ASSINATURA_RECEBEDOR = signatureBlockRecebedor(
      formData.NOME_RECEBEDOR,
      formData.CPF_CNPJ_RECEBEDOR,
      tipoDocRecebedor
    );
  }

  if (data.DATA) {
    data.DATA = formatDateBR(data.DATA);
  }

  return data;
}
